<template>
  <div>
    <v-card outlined>
      <v-card-text>
        <v-simple-table>
          <tbody class="profile_details">
            <tr>
              <td>
                <ul>
                  <li>professional licenses:</li>
                  <li>
                    {{ details.professional_licenses | capitalize }}
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>
                <ul>
                  <li>specialization Detail Name:</li>
                  <li>{{ details.specializationDetailName }}</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>
                <ul>
                  <li>registration number:</li>
                  <li>{{ details.registration_number }}</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>
                <ul>
                  <li>created:</li>
                  <li>{{ details.created | myDating }}</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Utils from "@/mixins/utils";
import Restful from "@/services/RestFul";

export default {
  props: {
    subscriber: { type: String },
  },
  mixins: [Utils],
  data: () => ({ subscribeList: [], loading: false, details: {} }),
  created() {
    this.findMe();
  },
  methods: {
    findMe() {
      let self = this;
      let id = this._decode(this.subscriber);
      console.log("id", id);
      Restful.mySubscriber
        .find(id)
        .then((response) => {
          console.log("findMe", response);
          if (response.status === 200) {
            this.subscribeList = response.data;
            this.details = response.data[0];
            console.log("detailxxx:", this.details);
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
        .catch((error) => {
          console.log(error.response);
          self.loading = false;
        });
    },
  },
};
</script>
